export const ADMIN_ROLE_SETTINGS_TABS = {
    SETTINGS: {
        name: 'settings',
        caption: 'Settings',
    },
    AUDIT_LOG: {
        name: 'audit-log',
        caption: 'Audit Log',
    },
};
